import { INIT_DATA } from './state'
import {set} from 'lodash-es'

export default {
  setSignInfo (state, payload) {
    const { data, path } = payload
    set(state, path, data)
  },

  setProgress (state, { propgress }) {
    state.propgress = { ...propgress }
  },

  resetSignInfo (state, payload) {
    state.signForm = { ...INIT_DATA }
  },

  updateAuditInfo (state, { auditInfo, shopList, shopId }) {
    state.auditInfo = {
      ...auditInfo,
      shop: shopList.filter(item => item.shopId === shopId)
    }
  },
  updateAuditStatus (state, auditStatus) {
    state.auditStatus = auditStatus
  },

  resetAudit (state) {
    state.auditInfo = {}
    state.auditStatus = {}
  },

  pickProcessStatus (state, { processType, status }) {
    const processStatus = state.processStatus
    state.processStatus = { ...processStatus, [processType]: status }
  },

  pickSignType (state, type) {
    state.signType = type
  },
  updateTaxSourceTypeConfig (state, payload) {
    state.configs = {
      ...state.configs,
      ...payload
    }
  }
}
